module.exports = __webpack_public_path__ + "img/next.5d02f6f5.png";